import { Colors } from '@/components/common';

export const exemptionStatus = Object.freeze({
  Submitted: 1,
  Approved: 2,
  Denied: 3,
  PartiallyApproved: 4,
  Amended: 5,
  Inactive: 6,
});

export const getStatusColor = (statusId) => {
  switch (statusId) {
    case exemptionStatus.Submitted:
      return Colors.YELLOW;
    case exemptionStatus.Approved:
    case exemptionStatus.PartiallyApproved:
      return Colors.GREEN;
    case exemptionStatus.Denied:
    case exemptionStatus.Amended:
      return Colors.BROWN;
    case exemptionStatus.Inactive:
      return Colors.GRAY;
    default:
      return `primary-13`;
  }
};
